import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Modal } from 'antd';
import { DownloadOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import Labels from './Labels.json';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { updateAuthorizationForm, deleteAuthorizationForm, getAuthrizationStatus } from '../../services/Service';
import { showErrorNotification, showNotification, showWarningNotification } from '../../utils/documentConfig';
import { fetchEmployeeData, DeleteConfirmButton } from '../../utils/documentConfig';


function DisplayAuthorization({ onFileUploadSuccess }) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileData, setFileData] = useState(null); // Stores Base64 Data
  const [isChecked, setIsChecked] = useState(false); // completion checkbox
  const [isAdmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState(null); // Store userId in state

  const { id } = useParams(); // Get userId from URL if available
  const email = localStorage.getItem("userEmail");
  const token = useSelector((state) => state.auth.token);



  useEffect(() => {
    const roleUser = JSON.parse(localStorage.getItem("userRoles"));

    if (roleUser && roleUser.includes("ADMINUSER")) {
      // alert("setAdmin");
      setIsAdmin(true);
    }

    // If userId is not available, fetch it using email
    if (!id) {
      fetchData();
    } else {
      setUserId(id); // Set from URL params
    }
  }, [id]); // Depend on id so it updates properly when URL changes

  useEffect(() => {
    if (userId) {
      handleGetStatus(); // Fetch status only after userId is available
    }
  }, [onFileUploadSuccess, userId]); // Depend on userId to trigger status check

  const fetchData = async () => {
    try {
      const fetchedUserId = await fetchEmployeeData(email);
      console.log(`User ID: ${fetchedUserId}`);
      setUserId(fetchedUserId);
    } catch (error) {
      console.error("Failed to fetch userId:", error);
      showNotification("Failed to fetch userId");
    }
  };

  const handleGetStatus = async () => {
    try {
      const response = await getAuthrizationStatus(userId);
      console.log("Response:", response);

      if (response.ok && response.status!=404) {
        const fileData = response.data;
        if(fileData.fileName !=null)
          {
          
          console.log("File data from response:", fileData);

          // Update state
          setUploadedFile(fileData.fileName);
          setFileName(fileData.fileName);
          setFileData(fileData.fileBase64);
          setIsChecked(true);
          onFileUploadSuccess(true);

          // Save to localStorage
        /*  localStorage.setItem(
            `authFile_${userId}`,
            JSON.stringify({
              fileName: fileData.filename,    // ✅ Correct key for filename
              fileBase64: fileData.fileData,  // ✅ Correctly reference fileData as base64
              isChecked: true,
            })
          );*/
        }
      } else {
        onFileUploadSuccess(false);
        //alert("Failed to retrieve BGV status");
      }
    } catch (error) {
      console.error("Failed to retrieve status:", error);
     showErrorNotification(`Failed to retrieve status.`);
    }
  };


  // Convert file to Base64 for storage
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!userId) {
      console.error("User ID not found in the URL!");
      showWarningNotification(`User ID is missing!`)
      //alert("User ID is missing!");
      return;
    }

    let newFileName = file.name;

    // Check if userId is already in the filename
    if (!file.name.includes(userId)) {
      newFileName = `${userId}_${file.name}`;
    }

    // Create a new File object with the final name
    const renamedFile = new File([file], newFileName, { type: file.type });

    const authForm = {
      uid: userId,
      status: 'Completed',
    };

    // ✅ Send file and JSON data separately
    const formData = new FormData();
    formData.append('file', renamedFile);
    formData.append('authForm', JSON.stringify(authForm));

    // const requestData = {file:renamedFile, userId: userId, status: "Completed" };
    // alert("OK");
    const base64 = await convertFileToBase64(renamedFile);
    try {
      const response = await updateAuthorizationForm(formData);
      if (response.ok) {
        const result = response.data;
        console.log("Upload successful:", result);
        showNotification(`File uploaded successfully as ${newFileName}`);
        //alert(`File uploaded successfully as ${newFileName}`);

        // Convert to Base64 and update state
        const base64 = await convertFileToBase64(renamedFile);
        const fileData = {
          fileName: newFileName,
          fileBase64: base64,
          isChecked: true,
        };

        setUploadedFile(newFileName);
        setFileName(newFileName);
        setFileData(base64);
        setIsChecked(true);
        onFileUploadSuccess(true);

        // Save to localStorage (unique for each user)
        //localStorage.setItem(`authFile_${userId}`, JSON.stringify(fileData));
      } else {
        const errorMsg = response.data.error;
        console.error("Upload failed:", errorMsg);
        showErrorNotification(`File upload failed as ${errorMsg}`);

        //alert("File upload failed: " + errorMsg);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      showErrorNotification("Upload failed: " + error.message);
      //alert("An error occurred while uploading the file.");
    }
  };
  const downloadDocument = async () => {
    try {
      const response = await getAuthrizationStatus(userId);
      console.log("Response:", response);
      
      if (response && response.data) {
                const fileData = response.data;
                console.log("File data from response:", fileData);
               
                const fileName = fileData.fileName;
                const fileExtension = fileName.split('.').pop().toLowerCase();
                const fileType = fileData.fileType;
      
                let base64Data = fileData.fileData;
                // 🛠️ Check if Base64 data is in a data URI format
                if (base64Data.startsWith('data:')) {
                  base64Data = base64Data.split(',')[1]; // Extract the base64 part
                }
      
                try {
                  
                  // ✅ Decode Base64 data to binary
                  const byteCharacters = atob(base64Data);
                  const byteNumbers = new Uint8Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
      
                  // ✅ Create a Blob with the correct type
                  const blob = new Blob([byteNumbers], { type: fileType });
                  const fileUrl = URL.createObjectURL(blob);
      
                  // ✅ Handle PDF separately, others trigger download
                  if (fileExtension === 'pdf') {
                    window.open(fileUrl, '_blank');
                  } else {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
      
                  // ✅ Clean up memory after download
                  setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
                } catch (decodeError) {
                  console.error('Error decoding Base64 data:', decodeError);
                  showErrorNotification('Failed to decode file data. File may be corrupted.');
                }
              } else {
                showWarningNotification('No file found for this user.');
              }
          } catch (error) {
            console.error('Error downloading file:', error);
            showErrorNotification('An error occurred while downloading the file.');
          }
  };
  const handleDownload = () => {
    // Extract UID from the URL
    // const urlParams = new URLSearchParams(window.location.search);
    //const userId = urlParams.get("uid"); // Assumes URL has ?uid=12345

    if (!userId) {
      console.error("User ID not found in the URL!");
      showWarningNotification(`User ID is missing!`);
      return;
    }

    // const fileUrl = `/documents/BGV_form.pdf`; // Adjust file path as needed

    const link = document.createElement("a");
    link.href = "/Authorization Letter.doc";
    link.download = `${userId}_Authorization_Letter.doc`; // Filename with UID
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  // Function to handle opening the uploaded document
  const handleOpenDocument = () => {

    if (!fileName) {
      console.error("No file uploaded or file data is missing.");
      showWarningNotification(`Please upload a valid file before opening.`);
      return;
    }

    try {
      const fileExtension = fileName.split('.').pop().toLowerCase();
      const fileBlob = fetch(fileData).then(res => res.blob());
      fileBlob.then(blob => {
        const fileUrl = URL.createObjectURL(blob);
        if (fileExtension === 'pdf') {
          window.open(fileUrl, '_blank');
        } else {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      });
    } catch (error) {
      console.error("Error opening document:", error);
      showErrorNotification(`An error occurred while opening the document. Please try again.${error}`);
    }
  };

  const handleDelete = async () => {
    if (!userId) {
      showWarningNotification(`User ID is required to delete the file.`);
      return;
    }

    /*Modal.confirm({
      title: 'Are you sure you want to delete this file?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {*/
        const userInput = userId;
        try {
          const response = await deleteAuthorizationForm(userInput);
          if (response.ok) {
            setUploadedFile(null);
            setFileName("");
            setFileData(null);
            setIsChecked(false);
            localStorage.removeItem(`authFile_${userId}`);
            onFileUploadSuccess(false);
            showNotification(`File deleted successfully`);
          } else {
            const errorMsg = response.data;
            showErrorNotification(`File upload failed as ${errorMsg}`)
            //alert("File deletion failed: " + errorMsg);
          }
        } catch (error) {
          showErrorNotification(`An error occurred while deleting the file.`);
        }
      /*},
      onCancel() {
        console.log('Deletion cancelled');
      },
    });*/
  };

  return (
    <div className="bordered-div userview_container">
      {/* Authorization Content Section */}
      <h2 className="custom-h2">{Labels.Authorization_Title}</h2>
      <p>{Labels.Authorization_Description}</p>

      {/* Download Button */}
      <Button
        type="primary"
        className="custom-button-download"
        onClick={handleDownload}
        icon={<DownloadOutlined />}
        disabled={isAdmin} // Disable download if user is admin

      >
        {Labels.Authorization_Download_Button}
      </Button>

      {/* Upload Button */}
      <input
        type="file"
        id="file-upload-auth"
        style={{ display: 'none' }}
        onChange={handleFileUpload}
        accept={Labels.Authorization_File_Upload_Accepted_Types}
        disabled={isAdmin || uploadedFile} // Disable upload if admin or file already uploaded
      />

      <Button
        type="primary"
        className="custom-button-upload"
        onClick={() => document.getElementById('file-upload-auth').click()}
        icon={<UploadOutlined />}
        disabled={isAdmin || uploadedFile} // Disable upload if admin or file already uploaded
      >
        {Labels.Authorization_Upload_Button}
      </Button>
      <br />

      {/* Display uploaded file name and link to open the document */}
      {fileName && (
        <div>
          <p>
            <strong>{Labels.Authorization_File_Upload_Label}</strong>
            <a href="#" onClick={downloadDocument} style={{ color: 'blue' }}>
              {fileName}
            </a>
            {/* Delete Button for Admin */}
            {isAdmin && (
              <DeleteConfirmButton
              onConfirm={() => handleDelete()}
              buttonLabel={Labels.Authorization_Delete_Button}
              />
            )}
          </p>
        </div>
      )}

      {/* Checkbox for User Authorization */}
      {uploadedFile && (
        <div>
          <Checkbox
            checked={isChecked}
            disabled={true}
            className="custom-checkbox"
          >
            <strong style={{ marginBottom: '16px', color: 'rgb(31, 64, 90)' }}>
              {Labels.Authorization_Completed_Label}
            </strong>
          </Checkbox>
        </div>
      )}
    </div>
  );
}

export default DisplayAuthorization;